var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{on:{"click":_vm.setComponent}},[_vm._v(_vm._s(_vm.$t("helpers.chat.contact")))])
}
var staticRenderFns = []

export { render, staticRenderFns }